import React, { useState } from "react";
import "./App.css";
import "./MainPage.css";

const bannerUrl = "/cor-logo-high-res_no_white.webp";

const LoginPage = () => {

    const [clicked, setClicked] = useState(false);
    const [hover, setHover] = useState(false);

    const handleClick = () => {
        setClicked(true);
        setTimeout(() => setClicked(false), 0); // Reset after animation
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        window.location.replace("/login");
        return;
    };

    return (
        <>
            <div className="top-banner">
                <img src={bannerUrl} alt="Banner" />
            </div>

            <div style={styles.container}>
                <h2 style={{marginBottom: 0}}>Login Failed</h2>
                <p style={{marginTop: 0}}>Please Try Again</p>
                <form onSubmit={handleSubmit} style={styles.form}>
                    <button
                        className={`animated-button ${clicked ? "clicked" : ""}`}
                        onClick={handleClick}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: hover ? "#1c5377" : "#113045",
                            color: "#fff",
                            transition: "background-color 150ms ease",
                        }}
                    >
                        <div style={{ fontSize: "1.2rem" }}>Back to Login</div>
                    </button>
                </form>
            </div>
        </>
    );
};

const styles = {
    container: {
        maxWidth: "400px",
        margin: "50px auto",
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        textAlign: "center",
    },
    form: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
    input: {
        margin: "10px 0",
        padding: "10px",
        fontSize: "16px",
    },
    button: {
        padding: "10px",
        fontSize: "16px",
        backgroundColor: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        width: "100%",
    },
    error: {
        color: "red",
        fontSize: "14px",
    },
};

export default LoginPage;
